import React from 'react'
import Questionnaire from '../../../components/admin/Dashboard/userQuestions/Questionnaire'
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

function PaymentRefQnA() {
    return (
        <>
            <Questionnaire />
        </>
    )
}

export default PaymentRefQnA